import { render, staticRenderFns } from "./TreeForm.vue?vue&type=template&id=36b8711c&scoped=true&"
import script from "./TreeForm.vue?vue&type=script&lang=js&"
export * from "./TreeForm.vue?vue&type=script&lang=js&"
import style0 from "./TreeForm.vue?vue&type=style&index=0&id=36b8711c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b8711c",
  null
  
)

export default component.exports